var _circle, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorfinderAddon = function SvgColorfinderAddon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.049,
    cy: 9.047,
    r: 4.971,
    stroke: "#fff",
    strokeWidth: 0.833,
    transform: "rotate(-45 9.049 9.047)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colorfinder-addon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "colorfinder-addon_svg__b",
    width: 8,
    height: 8,
    x: 5,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.05,
    cy: 9.047,
    r: 3.535,
    fill: "#d9d9d9",
    transform: "rotate(-45 9.05 9.047)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#colorfinder-addon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#colorfinder-addon_svg__c)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2412.53,
    height: 2412.53,
    x: -1206.27,
    y: -1206.27,
    transform: "rotate(45 -6.396 15.448)scale(.00354)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#eb5143 0deg,#f0f43c 121.815deg,#4c89e8 252.602deg,#eb5143 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.05 9.047 5-5 5 5-5 5z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":4.9993767738342285,\"m01\":-4.9993767738342285,\"m02\":9.0501585006713867,\"m10\":4.9993767738342285,\"m11\":4.9993767738342285,\"m12\":4.0479869842529297},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.422 13.055.635-.635 3.525 3.525-.635.635z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "colorfinder-addon_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.05 9.047 5-5 5 5-5 5z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorfinder-addon_svg__a",
    width: 8.737,
    height: 8.737,
    x: 4.682,
    y: 4.679,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12085_37792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_12085_37792",
    result: "shape"
  })))));
};
export default SvgColorfinderAddon;